import { once, PromiseReturnType, sleep, UnknownFunction } from '@voithru/front-core';
import React from 'react';

function useLoadingContextBuilder() {
  const [isLoading, setLoading] = React.useState((): Promise<unknown>[] => []);

  const loading = React.useCallback(<F extends UnknownFunction>(func: F) => {
    const oneFunc = once(func);

    return async (...args: Parameters<F>): Promise<PromiseReturnType<F>> => {
      async function runner(): Promise<PromiseReturnType<F>> {
        await sleep(0);
        return await oneFunc(...args);
      }

      const promise = runner().finally(() => setLoading((prev) => prev.filter((it) => it !== promise)));
      setLoading((prev) => prev.concat([promise]));

      return await promise;
    };
  }, []);

  return { isLoading, loading };
}

export default useLoadingContextBuilder;
